import { Component, effect, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { EventService } from '../../services/event.service';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { CHAINS } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-airdrop',
  standalone: false,
  templateUrl: './airdrop.component.html',
  styleUrl: './airdrop.component.scss',
})
export class AirdropComponent {
  email: string = '';
  emailError: string = '';
  successMessage: string = '';
  consent: boolean = false;
    public walletAddress: string = '';


  private readonly eventService = inject(EventService);
  private readonly dataService = inject(PresaleDataService);
 

  constructor() {
    effect(() => {
      this.dataService.walletAddressSignal();
      this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress;
    });
  }
  joinPresale(): void {
    this.eventService.showBuyWidget("home");
  }
    showWidget(): void {
 
     this.dataService.connectWallet();
   
  }
  subscribe() {
    this.emailError = '';
    this.successMessage = '';
    if (!this.email) {
      this.emailError = 'Please enter your email address.';
      return;
    }
    if (!this.validateEmail(this.email)) {
      this.emailError = 'Please enter a valid email address.';
      return;
    }

    const payload = {
      consent: true,
      email: this.email,
      projectIdentifier: environment.slug,
      site: window.location.href,
      actions: "email-subscribed",
      timestamp: Date.now()

    };

    this.eventService.broadcastEvent('UPDATE_CONSENT', payload);
    this.email = '';
    this.successMessage = 'Subscribed successfully!';
    setTimeout(() => {
      this.successMessage = '';
    }, 3000);
  }

  validateEmail(email: string): boolean {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }

}
